import { useState, useEffect } from "react";
import { X, PiggyBank, ArrowRight } from "lucide-react";

// Exit-intent: jednou za session, když uživatel míří kurzorem mimo okno (desktop).
const ExitIntentModal = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (sessionStorage.getItem("ed_exit_shown")) return;
    let armed = false;
    const arm = setTimeout(() => { armed = true; }, 4000);
    const onLeave = (e) => {
      if (armed && e.clientY <= 0) {
        setOpen(true);
        sessionStorage.setItem("ed_exit_shown", "1");
        document.removeEventListener("mouseleave", onLeave);
      }
    };
    document.addEventListener("mouseleave", onLeave);
    return () => { clearTimeout(arm); document.removeEventListener("mouseleave", onLeave); };
  }, []);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-fade-in-up" data-testid="exit-intent-modal" onClick={() => setOpen(false)}>
      <div className="relative max-w-md w-full glass rounded-2xl p-8 border border-orange-500/30 text-center" onClick={(e) => e.stopPropagation()}>
        <button onClick={() => setOpen(false)} className="absolute top-3 right-3 text-zinc-500 hover:text-white" data-testid="exit-intent-close" aria-label="Zavřít"><X className="w-5 h-5" /></button>
        <div className="w-14 h-14 rounded-2xl bg-orange-500/15 flex items-center justify-center mx-auto mb-4"><PiggyBank className="w-7 h-7 text-orange-400" /></div>
        <h3 className="font-['Cabinet_Grotesk'] text-xl font-bold mb-2">Než odejdete…</h3>
        <p className="text-zinc-300 text-sm mb-6">Než půjdete – mrkněte, proč je EffectDeal flexibilnější než operák i výhodnější než klasická půjčovna. Bez dlouhých závazků a vše v ceně.</p>
        <a href="#comparison" onClick={() => setOpen(false)} className="btn-accent w-full inline-flex items-center justify-center gap-2" data-testid="exit-intent-cta">Proč EffectDeal? <ArrowRight className="w-4 h-4" /></a>
      </div>
    </div>
  );
};

export default ExitIntentModal;
